import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { getEngine } from "../state/engine-bridge.svelte";
import { art } from "../state/params.svelte";
import { download } from "../util/download";
import { showToast } from "./Toast.svelte";

var $$_import_art = $.reactive_import(() => art);
var root = $.from_html(`<button class="svelte-3nk667mhvmrro"><span class="scale svelte-3nk667mhvmrro"> </span> <span class="dims svelte-3nk667mhvmrro"> </span></button>`);
var root_1 = $.from_html(`<div class="menu svelte-3nk667mhvmrro" role="group" aria-label="Export size"></div>`);

export default function ExportMenu($$anchor, $$props) {
	$.push($$props, false);

	const maxScale = getEngine()?.maxExportScale() ?? 1;
	const scales = [1, 2, 4].filter((s) => s <= maxScale);

	// Exports are CSS size x scale (dpr-independent), so output dims derive
	// from the window size in CSS px (the engine exposes no size getter).
	const baseW = Math.round(window.innerWidth);

	const baseH = Math.round(window.innerHeight);

	async function pick(scale) {
		const engine = getEngine();

		if (!engine || $$_import_art().exporting) return;

		$$_import_art($$_import_art().exportMenuOpen = false);
		$$_import_art($$_import_art().exporting = true);

		try {
			const blob = await engine.exportPNG(scale);

			download(blob, `eigenvisuals-${$$_import_art().seed}.png`);
			showToast("Saved");
		} catch {
			showToast("Export failed at this size");
		} finally {
			$$_import_art($$_import_art().exporting = false);
		}
	}

	$.init();

	var div = root_1();

	$.each(div, 5, () => scales, (s) => s, ($$anchor, s) => {
		var button = root();
		var span = $.child(button);
		var text = $.child(span);

		$.reset(span);

		var span_1 = $.sibling(span, 2);
		var text_1 = $.child(span_1);

		$.reset(span_1);
		$.reset(button);

		$.template_effect(() => {
			$.set_text(text, `${$.get(s) ?? ''}×`);
			$.set_text(text_1, `${baseW * $.get(s)} × ${baseH * $.get(s)}px`);
		});

		$.delegated('click', button, () => pick($.get(s)));
		$.append($$anchor, button);
	});

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);
import "bun-svelte:ExportMenu.svelte-2f8vs36y69ur3-style.css";